import md5 from 'md5';
const softObj: {
  [key: string]: string
} = {
  jfztADV: 'sylapp.cn',
  tzyk: 'get88.cn',
  fdgmg: 'techfx88.com'
}
const authInfo: {
  [key: string]: object
} = {
  jfztADV: {
    "AppKey": "pc",
    "AppSecret": "befa3635-8d86-42b3-a157-637db2a52554",
    "Name": "jfztADV",
    "Desc": "九方智投",
    "Version": getUrlSearch('version') || '',
    "Type": "h5",
  },
  tzyk: {
    "AppKey": "pc",
    "AppSecret": "befa3635-8d86-42b3-a157-637db2a52554",
    "Name": "tzyk",
    "Desc": "大阳智投",
    "Version": getUrlSearch('version') || '',
    "Type": "h5",
  },
  fdgmg: {
    "AppKey": "pc",
    "AppSecret": "befa3635-8d86-42b3-a157-637db2a52554",
    "Name": "fdgmg",
    "Desc": "方德港美股",
    "Version": getUrlSearch('version') || '',
    "Type": "h5",
  },
  jfztGW: {
    "AppKey": "jf",
    "AppSecret": gwSecret(),
    "Name": "jfztgw",
    "Desc": "九方智投官网",
    "Version": "1.0.0",
    "Type": "h5",
  }
}
function gwSecret() {
  return location.hostname.includes('test') ? "6dff2f6b-5d0c-433e-9355-95a0be35d04b" : "beff3635-8c86-42c3-a157-637db2c52554"
}
function getUrlSearch(name: any) {
  // 未传参，返回空
  if (!name) return null;
  // 查询参数：先通过search取值，如果取不到就通过hash来取
  var after = window.location.search;
  after = after.substr(1) || window.location.hash.split('?')[1];
  // 地址栏URL没有查询参数，返回空
  if (!after) return null;
  // 如果查询参数中没有"name"，返回空
  if (after.indexOf(name) === -1) return null;

  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  // 当地址栏参数存在中文时，需要解码，不然会乱码
  var r = decodeURI(after).match(reg);
  // 如果url中"name"没有值，返回空
  if (!r) return null;
  console.log(r, 'rrr')
  return r[2];
}
/**
 * 获取量化接口请求头
 */
function getQuantAuthHeaders() {
  const appcode = 'com.fdzq.pc'
  const timestamp = Date.now().toString() // 动态时间戳
  const secret = '4bf5ff9e466d432c842c068c4ae0a30a' || '' // 用 auth 里的 AppSecret，或者你单独写死也行
  const signature = md5(`${secret}:${timestamp}`)

  return {
    appcode,
    timestamp,
    signature,
  }
}


const softNameAbbr = getUrlSearch('softNameAbbr') || 'jfztADV' as string
const host = softObj[softNameAbbr]
const hostname = location.hostname
function getUrl(furl = '', aurl = '') {
  return host ? furl + host + aurl : furl + 'sylapp.cn' + aurl
}
function getTokenUrl() {
  return hostname.includes('test') || hostname.includes('localhost') ? 'https://test-hqpassport.9fh5.com/api/v2/AuthGetToken' : getUrl('https://hqpassport.', '/api/v2/AuthGetToken')
}
function getWsUrl() {
  return 'wss://hqsys-aweb.sylapp.cn/hq/lh/json'
}

function getSearchUrl() {
  return hostname.includes('test') || hostname.includes('localhost') ? 'https://test-qas-search.9fh5.com' : getUrl('https://qas-search.')
}
function getBaseUrl() {
  return hostname.includes('test') || hostname.includes('localhost') ? 'https://test-infocenter.9fh5.com' : getUrl('https://infocenter.')
}
function getYesUrl() {
  return hostname.includes('test') ? 'https://test-infocenter.9fh5.com/qas/api/v30' : getUrl('https://infocenter.', '/qas/api/v30')

}
function getOptionalStockUrl() {
  return hostname.includes('test') ? 'https://test-gateway.9fh5.com' : getUrl('https://gateway.')
}
function getWayUrl() {
  return hostname.includes('test') ? 'https://test-gateway.jinyi999.cn' : 'https://gateway.chongnengjihua.com'
}
/** NewChat / fd-im 专用网关（仅该页接口使用） */
function getFdImUrl() {
  return hostname.includes('test') || hostname.includes('localhost')
    ? 'https://test-gateway.jinyi999.cn/fd-im'
    : 'https://rh-gw.forthright-sec.com.hk/fd-im'
}
function getEduUrl() {
  return hostname.includes('test') ? 'https://test-api-edu.jinyi999.cn' : 'https://api-edu.chongnengjihua.com'
}
function getStockPoolUrl() {
  // 测试环境临时改成生产地址
  return hostname.includes('test') ? 'https://test-baseinfo.9fh5.com' : getUrl('https://baseinfo.')
}
function getSectorRelationUrl() {
  return hostname.includes('test') ? 'https://test-api-hg.jinyi999.cn' : 'https://api-hq.chongnengjihua.com'
}
function getCMS() {
  return hostname.includes('test') || hostname.includes('localhost') ? 'https://dev-api-cms.techfx88.com' : 'https://api-cms.techfx88.com'
}
function getCMS2() {
  return hostname.includes('test') || hostname.includes('localhost')
    ? 'https://dev-cms2.techfx88.com'
    : 'https://cms2.techfx88.com'
}
function getLink() {
  return hostname.includes('test') ? 'https://dev-api-link.techfx88.com' : 'https://api-link.techfx88.com'
}
function getQuantUrl() {
  return hostname.includes('test') || hostname.includes('localhost')
    ? 'https://test-quant.techfx88.com'
    : 'https://quant.techfx88.com'
  // ? 'https://quant.techfx88.com'
  // : 'https://test-quant.techfx88.com'
}

// 获取quotes
function getQuotes() {
  return hostname.includes('test') || hostname.includes('localhost')
    ? 'https://dev-apistock2.techfx88.com'
    : 'https://apistock2.techfx88.com'
  // ? 'https://apistock2.techfx88.com'
  // : 'https://dev-apistock2.techfx88.com'
}

// 获取 测试：https://dev-apitrade.techfx88.com

// 生产：https://apitrade.techfx88.com

function getQuotesapitrade() {
  return hostname.includes('test') || hostname.includes('localhost')
    ? 'https://dev-apitrade.techfx88.com'
    : 'https://apitrade.techfx88.com'
  // ? 'https://apitrade.techfx88.com'
  // : 'https://dev-apitrade.techfx88.com'
}

function getApiUrl() {
  return hostname.includes('test') || hostname.includes('localhost') ? 'https://test-api.techgp.cn/ql/pc' : 'https://api.9fapi.cn/ql/pc'
  // return  'https://api.9fapi.cn/ql/pc'
}

function getCourseApiUrl() {
  // return  'https://test-api.techgp.cn/ql/pc'
  // return  'https://api.chongnengjihua.com/ql/pc'
  // return 'https://api.9fapi.cn/ql/pc'
  return hostname.includes('test') || hostname.includes('localhost') ? 'https://test-api.techgp.cn/ql/pc' : 'https://api.9fapi.cn/ql/pc'
}

const isLocalDev = process.env.NODE_ENV === 'development' || ['localhost', '127.0.0.1'].includes(location.hostname)

function getIndexPoolUrl() {
  // 本地开发使用代理，避免跨域
  if (isLocalDev) {
    return '/indexPoolApi'
  }
  return hostname.includes('test') || hostname.includes('localhost') ? 'https://test-pcstatic.sylapp.cn' : 'https://pcstatic.sylapp.cn'
}

function getInfoFDUrl() {
  return hostname.includes('test') || hostname.includes('localhost')
    ? 'https://test-gateway.eprobex.com'
    : 'https://gateway.eprobex.com'
}

const auth = authInfo[softNameAbbr]
const tokenurl = getTokenUrl()
const wsurl = getWsUrl()
const searchurl = getSearchUrl()
const baseurl = getBaseUrl()
const yesurl = getYesUrl()
const optionalStockUrl = getOptionalStockUrl()
const f10url = getBaseUrl()
const getwayurl = getWayUrl()
const fdImUrl = getFdImUrl()
const eduurl = getEduUrl()
const stockpoolurl = getStockPoolUrl()
const sectorrelationurl = getSectorRelationUrl()
const apiUrl = getApiUrl()
const quanturl = getQuantUrl()
const getquotes = getQuotes()
const getQuotesapitrades = getQuotesapitrade()
const getCMSUrl = getCMS()
const getCMS2Url = getCMS2()
const getLinkUrl = getLink()
const indexPoolUrl = getIndexPoolUrl()
const infoFDUrl = getInfoFDUrl()
export {
  getUrl,
  auth,
  tokenurl,
  wsurl,
  searchurl,
  baseurl,
  yesurl,
  optionalStockUrl,
  f10url,
  getwayurl,
  fdImUrl,
  eduurl,
  sectorrelationurl,
  stockpoolurl,
  apiUrl,
  quanturl,
  getquotes,
  getQuotesapitrades,
  getCMSUrl,
  getCMS2Url,
  getLinkUrl,
  getQuantAuthHeaders,
  isLocalDev,
  indexPoolUrl,
  infoFDUrl,
  getCourseApiUrl
}
